import {
  WorkflowStateSelection,
  WorkflowStateSelectionConfigDto,
} from '@asset-metrix/portal-gateway-client-js';
import type { StateCreator } from 'zustand';

import { RemoveFunctions } from '../../utils/types';

export type WorkflowStateSelectionSlice = {
  workflowStateSelections: {
    [entityId in string]?: WorkflowStateSelection[];
  };
  addWorkflowStateSelection(
    entityId: string,
    newSelection: WorkflowStateSelection
  ): void;
  removeWorkflowStateSelection(
    entityId: string,
    selectionToRemove: string
  ): void;
  initWorkflowStateSelection(
    entityId: string,
    config: WorkflowStateSelectionConfigDto
  ): void;
  cloneWorkflowStateSelection(entityFrom: string, entityTo: string): void;
  deleteWorkflowStateSelection(entityId: string): void;
  resetWorkflowStateSelectionSlice(): void;
};

const initialState: RemoveFunctions<WorkflowStateSelectionSlice> = {
  workflowStateSelections: {},
};

export const createWorkflowStateSelectionSlice: StateCreator<
  WorkflowStateSelectionSlice,
  [],
  [],
  WorkflowStateSelectionSlice
> = (set) => {
  return {
    ...initialState,
    addWorkflowStateSelection(entityId, newSelection) {
      set((state) => ({
        workflowStateSelections: {
          ...state.workflowStateSelections,
          [entityId]: [
            ...(state.workflowStateSelections[entityId] ?? []),
            newSelection,
          ],
        },
      }));
    },
    removeWorkflowStateSelection(entityId, selectionToRemove) {
      set((state) => ({
        workflowStateSelections: {
          ...state.workflowStateSelections,
          [entityId]: state.workflowStateSelections[entityId]?.filter(
            ({ label }) => label !== selectionToRemove
          ),
        },
      }));
    },
    initWorkflowStateSelection(entityId, config) {
      set((state) => {
        if (state.workflowStateSelections[entityId]) {
          return state;
        }

        return {
          workflowStateSelections: {
            ...state.workflowStateSelections,
            [entityId]: config.options.filter(
              (option) => option.initiallyChecked
            ),
          },
        };
      });
    },
    cloneWorkflowStateSelection(entityFrom, entityTo) {
      set((state) => {
        return {
          workflowStateSelections: {
            ...state.workflowStateSelections,
            [entityTo]: state.workflowStateSelections[entityFrom],
          },
        };
      });
    },
    deleteWorkflowStateSelection(entityId) {
      set((state) => {
        const newState = {
          workflowStateSelections: {
            ...state.workflowStateSelections,
          },
        };

        delete newState.workflowStateSelections[entityId];

        return newState;
      });
    },
    resetWorkflowStateSelectionSlice() {
      set({ ...initialState });
    },
  };
};
